if (!customElements.get('article-gallery')) {
  customElements.define(
    'article-gallery',
    class ArticleGallery extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.article-gallery__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
        };

        this.parentBlock = this.closest('.article__gallery');
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        if (!this.parentBlock || !this.sliderWrapper) return;
        if (this.sliderWrapper.children.length < 2) return;

        this.sliderInstance = false;
        this.init();
      }

      init() {
        if (typeof this.sliderInstance === 'object') return;

        this.sliderOptions = {
          slidesPerView: 1.2,
          spaceBetween: 14,
          grabCursor: true,
          simulateTouch: true,
          allowTouchMove: true,
          navigation: {
            nextEl: this.parentBlock.querySelector(this.selectors.nextEl),
            prevEl: this.parentBlock.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.parentBlock.querySelector(this.selectors.pagination),
            type: 'progressbar',
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          },
          loop: false,
          threshold: 2,
          watchSlidesProgress: true,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
        };

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, [FoxTheme.Swiper.Mousewheel]);
        this.sliderInstance.init();
      }
    }
  );
}
